import styled, { css } from 'styled-components'
import { DEVICES } from '../../../constants/global'
import { COLORS } from '@styles/colors'
import { FONTS } from '@styles/fonts'

export const ListingCategory = styled.h2`
  margin-right: 26px;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 1px;
  color: ${COLORS.secondary};
  font-family: ${FONTS.medium};
  text-transform: uppercase;

  @media ${DEVICES.tablet} {
    display: block;
    margin-bottom: 8px;
  }
`

export const KeyDetail = styled.div`
  display: inline-flex;
  align-items: center;
  margin-right: 22px;
  white-space: nowrap;
  line-height: 20px;
  font-size: 16px;

  @media ${DEVICES.mobile} {
    margin-bottom: 4px;
  }

  svg {
    margin-left: 8px;
  }

  ${({ area }) =>
    area &&
    css`
      @media ${DEVICES.mobile} {
        display: block;
      }
    `}
`

export const KeyDetailValue = styled.div``

export const KeyDetails = styled.div`
  display: flex;
  align-items: center;
  color: ${COLORS.secondary};
  flex-wrap: wrap;
  margin-bottom: 44px;

  @media ${DEVICES.mobile} {
    margin-bottom: 40px;
    display: block;
  }

  ${({ isGalleryView }) =>
    isGalleryView &&
    css`
      display: block;

      ${ListingCategory} {
        display: block;
        margin-bottom: 12px;
      }

      ${KeyDetail} {
        margin-bottom: 4px;
      }
    `}
`